export default {
  title: 'Activos',

  'menu.import': 'Importar',
  'menu.importHistory': 'Historial de importación',
  'menu.export': 'Exportar',
  'menu.exportHistory': 'Historial de exportación',
  'menu.triggers': 'Automatizaciones',
  'menu.fields': 'Personalizar campos adicionales',

  'fields.NAME': 'Nombre',
  'fields.PLACE_NAME': 'Local/Persona/Flota',
  'fields.TYPE_NAME': 'Tipo',

  'menu.qrcode': 'Generador de QR Code',
  'menu.buckets': 'Historial de lotes de QR Code',

  'menu.linktree': 'Personalizar menú de QR Code',
  name: 'Nombre',
  type: 'Tipo',
  enabled: 'Activado'
}
